import React from 'react';

function Footer() {
  const currentYear = 2022;

  return (
    <footer className="bg-secondary pb-4 pt-6 h-32">
  <div className="container mx-auto flex flex-col lg:flex-row justify-between items-center text-center text-white px-10">
    <div className="mb-2 lg:mb-0">
      <p className="font-bold text-xl lg:text-xl">DEV.NEWS</p>
    </div>
    <div className="lg:text-lg">
      <p className="mb-2 lg:mb-0">By @<a href="https://github.com/rishikush31" className="text-blue-300 hover:text-blue-400">rishikush</a></p>
    </div>
  </div>
  <div className="container text-center text-slate-500 mt-5">
    © {currentYear} dev.news . All rights reserved.
  </div>
</footer>

  );
}

export default Footer;
